<template>
  <div class="addsubject">
    <div>
      <h3>课程基本信息</h3>
      <div class="section">
        <a-row type="flex">
          <a-col :span="userRole=='youwei_admin'?6:8" v-if="userRole=='youwei_admin'">
            <span><span style="color: red">*</span>所属公司：</span>
            <a-tree-select style="width: 160px; margin-right: 10px" v-model="formData.companyId" allowClear
              :treeData="deptLists" :show-checked-strategy="SHOW_PARENT" placeholder="所属公司" :replaceFields="options"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1" @change="deptchange"
              :disabled="id != 0">
            </a-tree-select>
          </a-col>
          <a-col :span="userRole=='youwei_admin'?6:8">
            <span><span style="color: red">*</span>课程类别：</span>
            <a-select v-model="formData.courseType" @change="oncourseTypeChange" placeholder="请选择"
              style="width: 180px; margin-right: 10px">
              <a-select-option :value="item.id" v-for="(item, index) in categoryList" :key="index">
                {{ item.categoryName }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="userRole=='youwei_admin'?6:8">
            <span><span style="color: red">*</span>课程名称：</span>
            <a-select v-model="formData.courseIds" mode="multiple" placeholder="请选择"
              style="width: 180px; margin-right: 10px">
              <a-select-option :value="item.id" v-for="item in allCourseLis" :key="item.id"
                :class="item.issueFlag==2?'selectNoShow':''">
                {{ item.courseName }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="userRole=='youwei_admin'?6:8">
            <span><span style="color: red">*</span>题型：</span>
            <a-select v-model="formData.type" placeholder="请选择" style="width: 180px; margin-right: 10px"
              :disabled="id != 0">
              <a-select-option value="1"> 单选 </a-select-option>
              <a-select-option value="2"> 多选 </a-select-option>
              <a-select-option value="3"> 判断 </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
    </div>
    <div>
      <h3>题干</h3>
      <div class="section">
        <a-input type="textarea" v-model="formData.content" style="height: 120px"></a-input>
      </div>
    </div>
    <div>
      <h3>选项及答案</h3>
      <div class="section question">
        <h4>勾选正确答案</h4>
        <!-- 单选 -->
        <a-radio-group v-model="singleAnswer" v-if="formData.type == 1">
          <a-row v-for="(item, index) in formData.optionsInfos" :key="index">
            <a-col :span="24">
              <a-radio :value="letterLis[index]"> {{ letterLis[index] }}： </a-radio>
              <a-input style="flex: 1" v-model="item.content"></a-input>
              <a-icon style="font-size: 18px; color: red; margin-left: 10px" type="delete" @click="delAnswer(index)"
                v-if="formData.optionsInfos.length > 3" />
            </a-col>
          </a-row>
        </a-radio-group>
        <!-- 多选 -->
        <a-checkbox-group v-model="muiltAanswer" v-if="formData.type == 2">
          <a-row v-for="(item, index) in formData.optionsInfos" :key="index">
            <a-col :span="24">
              <a-checkbox :value="letterLis[index]"> {{ letterLis[index] }}： </a-checkbox>
              <a-input style="flex: 1" v-model="item.content"></a-input>
              <a-icon style="font-size: 18px; color: red; margin-left: 10px" type="delete" @click="delAnswer(index)"
                v-if="formData.optionsInfos.length > 3" />
            </a-col>
          </a-row>
        </a-checkbox-group>
        <!-- 判断 -->
        <a-radio-group v-model="judgeAnswer" v-if="formData.type == 3">
          <a-row>
            <a-col :span="24">
              <a-radio :value="1"> 对 </a-radio>
              <a-radio :value="2"> 错 </a-radio>
            </a-col>
          </a-row>
        </a-radio-group>
        <div>
          <a-button type="link" @click="addAnswer" v-if="formData.type != 3 && formData.optionsInfos.length < 8">
            添加选项
          </a-button>
        </div>
      </div>
    </div>
    <div>
      <h3>添加图片</h3>
      <div class="section" style="display: flex; flex-wrap: wrap">
        <div class="imgBox" v-for="(item, index) in imgUrl" :key="index">
          <a-icon type="close-circle" class="delImg" @click="delImage(index)" v-if="imgUrl" />
          <div class="showImg" :style="{ backgroundImage: 'url(' + item.preUrl + ')' }" v-if="imgUrl"></div>
        </div>
        <div class="imgBox">
          <a-icon type="plus" />
          <input type="file" @change="selectImg" class="hiddenInput" />
          <!-- <a-icon type="close-circle" class="delImg" @click="delImage" v-if="imgUrl" />
          <div class="showImg" :style="{ backgroundImage: 'url(' + imgUrl + ')' }" v-if="imgUrl"></div> -->
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex">
      <a-button @click="returnBack">取消</a-button>
      <a-button type="primary" @click="addNewSubject">{{ id ? '保存' : '创建' }}</a-button>
    </div>
  </div>
</template>

<script>
import {
  getAllCourse,
  getCategoryLis,
  getQuestionDetail,
  letterLis,
  addQuestion,
  updateQuestion,
  getQuestionLis,
  delUploadImg,
  getCueseLists,
} from '../../../api/course'
import { tree_all } from '../../../api/purchase'
import axios from 'axios'
export default {
  data() {
    return {
      formData: {
        companyId: undefined,
        courseType: undefined, // 课程类别
        courseIds: [], // 课程名称
        type: '1',
        content: '',
        answer: '',
        optionsInfos: [{ content: '' }, { content: '' }, { content: '' }, { content: '' }],
        uuid: '',
      },
      data: [],
      tableScrollY: '',
      allCourseLis: [],
      categoryList: [],
      singleAnswer: '',
      muiltAanswer: [],
      judgeAnswer: '',
      letterLis: letterLis,
      imgUrl: [],
      timeTemp: '',
      id: '',
      cantChangeSelect: false,
      userInfo: {},
      userRole: '',
      deptObj: {},
      deptLists: [],
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
    this.timeTemp = Date.now()
    this.getDeptLists()
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id)
      this.getCourseDetail()
    } else {
      // if (this.userRole != 'youwei_admin') {
      //   this.getCategoryList()
      // }
    }
  },
  methods: {
    deptchange() {
      this.formData.courseType = undefined
      this.formData.courseIds = []
      this.getCategoryList()
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        let deptObj = {}
        if (this.userRole == "youwei_admin") {
          let data = res.data[0]
          for (let i = 0; i < data.length; i++) {
            deptObj[data[i].deptId] = data[i]
          }
          this.deptObj = JSON.parse(JSON.stringify(deptObj))
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                delete lists[i].children
              }
            }
          }
          formatDept(data)
          this.deptLists = data
        } else {
          this.deptLists = res.data[0]
          this.formData.companyId = res.data[0].deptId
          this.getCategoryList()
        }
      })
    },
    getCourseDetail() {
      getQuestionLis({ id: Number(this.$route.query.id) }).then(async (res) => {
        if (res.code != 200) {
          return
        }
        let info = res.data.list[0]
        this.formData.companyId = info.deptId
        this.formData.content = info.content
        this.formData.courseType = info.courseType
        this.formData.type = String(info.type) || '1'
        let params = {
          companyId: this.formData.companyId,
          issueFlag: 1,
        }
        let reslove = await getCategoryLis(params)
        if (reslove.code != 200) {
          return this.$message.error(reslove.msg)
        }
        this.categoryList = reslove.data.list
        if (!info.optionInfos || !info.optionInfos.length) {
          this.formData.optionsInfos = [{ content: '' }, { content: '' }, { content: '' }, { content: '' }]
        } else {
          this.formData.optionsInfos = info.optionInfos
        }
        if (info.categoryName) {
          for (let i = 0; i < this.categoryList.length; i++) {
            if (info.categoryName == this.categoryList[i].categoryName) {
              this.formData.courseType = this.categoryList[i].id
              this.getAllCourseLis(this.formData.courseType, info.courseInfo)
              break
            }
          }
        }
        if (info.imgList.length) {
          this.timeTemp = info.imgList[0].tempId
          for (let i = 0; i < info.imgList.length; i++) {
            this.imgUrl.push(info.imgList[i])
          }
        }
        if (info.tempId) {
          for (let i = 0; i < this.categoryList.length; i++) {
            if (info.categoryName == this.categoryList[i].categoryName) {
              this.formData.courseType = this.categoryList[i].id
              this.getAllCourseLis(this.formData.courseType, info.courseInfo)
              break
            }
          }
        }
        if (info.type == 1) {
          this.singleAnswer = info.answer
        } else if (info.type == 2) {
          this.muiltAanswer = info.answer.split(';')
        } else if (info.type == 3) {
          this.cantChangeSelect = true
          this.judgeAnswer = Number(info.answer)
        }
      })
    },
    addNewSubject() {
      if (!this.formData.courseType) {
        return this.$message.error('请选择课程类别')
      }
      if (!this.formData.courseIds.length) {
        return this.$message.error('请选择课程名称')
      }
      if (!this.formData.content) {
        return this.$message.error('请填写题干')
      }
      let params = JSON.parse(JSON.stringify(this.formData))
      if (params.type == 1) {
        if (!this.singleAnswer) {
          return this.$message.error('请勾选正确答案')
        }
        params.answer = this.singleAnswer
        params.score = 2
        for (let i = 0; i < params.optionsInfos.length; i++) {
          params.optionsInfos[i]['sortField'] = this.letterLis[i]
          if (!params.optionsInfos[i].content) {
            return this.$message.error('请填写选项内容')
          }
        }
      } else if (params.type == 2) {
        if (!this.muiltAanswer.length) {
          return this.$message.error('请勾选正确答案')
        }
        params.answer = this.muiltAanswer.join(';')
        params.score = 2
        for (let i = 0; i < params.optionsInfos.length; i++) {
          params.optionsInfos[i]['sortField'] = this.letterLis[i]
          if (!params.optionsInfos[i].content) {
            return this.$message.error('请填写选项内容')
          }
        }
      } else if (params.type == 3) {
        if (!this.judgeAnswer) {
          return this.$message.error('请勾选正确答案')
        }
        params.answer = this.judgeAnswer
        params.score = 1
        params.optionsInfos = []
      }
      if (this.id) {
        params.id = this.id
        updateQuestion(params).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('保存成功')
          this.returnBack()
        })
      } else {
        addQuestion(params).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('保存成功')
          // this.returnBack()
          this.formData.content = ''
          this.formData.answer = ''
          this.formData.optionsInfos = [{ content: '' }, { content: '' }, { content: '' }, { content: '' }]
          this.formData.uuid = ''
          this.imgUrl = []
          this.singleAnswer = ''
          this.muiltAanswer = []
          this.judgeAnswer = ''
          this.timeTemp = Date.now()
        })
      }
    },
    addAnswer() {
      this.formData.optionsInfos.push({ content: '' })
    },
    delAnswer(index) {
      this.formData.optionsInfos.splice(index, 1)
    },
    delImage(index) {
      let _this = this
      if (this.imgUrl[index].id) {
        this.$confirm({
          title: '提示',
          content: '删除图片操作无法逆转，是否确认删除此图片?',
          okText: '确定',
          cancelText: '取消',
          onOk() {
            delUploadImg({
              types: _this.imgUrl[index].types,
              path: _this.imgUrl[index].url,
            }).then((res) => {
              if (res.code != 200) {
                return _this.$message.error(res.msg)
              }
              _this.$message.success('删除成功')
              _this.imgUrl.splice(index, 1)
            })
          },
          onCancel() {
            _this.$message.info('已取消操作')
          },
        })
      } else {
        this.imgUrl.splice(index, 1)
      }
    },
    oncourseTypeChange() {
      this.formData.courseIds = []
      this.getAllCourseLis(this.formData.courseType)
    },
    getAllCourseLis(trainId, lists) {
      let params = {
        companyId: this.formData.companyId,
        trainIds: trainId,
        issueFlag: 1
      }
      getCueseLists(params).then((res) => {
        if (res.code != 200) {
          return
        }
        this.allCourseLis = res.data.list
        if (lists && lists.length) {
          console.log(lists.length)
          let arr = []
          for (let i = 0; i < this.allCourseLis.length; i++) {
            for (let j = 0; j < lists.length; j++) {
              if (lists[j].courseName == this.allCourseLis[i].courseName) {
                arr.push(this.allCourseLis[i].id)
              }
            }
          }
          this.formData.courseIds = arr
        }
      })
    },
    getCategoryList() {
      let params = {
        companyId: this.formData.companyId,
        issueFlag: 1,
      }
      getCategoryLis(params).then((res) => {
        if (res.code != 200) {
          return
        }
        this.categoryList = res.data.list
      })
    },
    selectImg(e) {
      if (e.target.value) {
        let file = e.target.files[0]
        e.target.value = ''
        if (file.size / 1024 / 1024 > 10) {
          return this.$message.error('上传文件大小不能超过 10MB!')
        }
        if (file.type.indexOf('image') == -1) {
          return this.$message.error('只能上传图片文件')
        }
        this.uploadImg(file, this.timeTemp).then((res) => {
          this.formData.uuid = this.timeTemp
          this.imgUrl.push({ preUrl: res.data.url[0].url })
        })
      }
    },
    uploadImg(file, timeTemp) {
      let params = new FormData()
      params.append('file', file)
      params.append('path', 'course' + this.formData.courseType)
      params.append('types', 'question-bank')
      params.append('delFlag', 2)
      params.append('tempId', timeTemp)
      axios.defaults.headers['token'] = localStorage.getItem('Access-Token').replace(/"/g, '')
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_API_BASE_URL + '/file/file/upload',
          method: 'post',
          data: params,
        }).then((res) => {
          resolve(res.data)
        })
      })
    },
    returnBack() {
      this.$router.push({
        path: '/training/database',
      })
    },
  },
}
</script>

<style scoped lang="less">
.addsubject {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0 6px 30px;
  h3 {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .section {
    width: 100%;
    padding: 20px 30px;
    box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin-bottom: 10px;
  }
  .question {
    .ant-radio-group {
      width: 100%;
    }
    .ant-checkbox-group {
      width: 100%;
    }
    .ant-col-24 {
      display: flex;
      width: 100%;
      align-items: center;
      margin-bottom: 10px;
      .ant-checkbox-wrapper {
        font-size: 18px;
        display: flex;
        align-items: center;
        .ant-checkbox {
          top: 0;
        }
      }
      .ant-radio-wrapper {
        font-size: 18px;
        display: flex;
        align-items: center;
      }
    }
  }
  .imgBox {
    width: 160px;
    height: 160px;
    border-radius: 2px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    position: relative;
    margin: 0 8px 8px 0;
    .hiddenInput {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 9;
    }
    .delImg {
      position: absolute;
      right: -6px;
      top: -6px;
      font-size: 20px;
      color: red;
      z-index: 10;
      cursor: pointer;
    }
    .showImg {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
</style>